import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CouponFilterEntity } from '../../domain/entities/CouponFilterEntity'

export class CouponFilterModel extends CouponFilterEntity {
  userId?: string
  branchId?:number
  regionId?: number
    channelId?: number
    groupId?: number

  constructor(dataDto: CouponFilterEntity) {
    super()
    mapEntityProperties<CouponFilterModel>(this, dataDto,{
      exclude: ['user', 'branch', 'region', 'channel', 'group' ],
      map:{
        branchId:dataDto.branch?.id,
        userId: dataDto.user?.id,
         regionId: dataDto?.region?.id,
         channelId: dataDto?.channel?.id,
         groupId: dataDto?.group?.id,
   }
    })
  }
}
 